import { render, staticRenderFns } from "./SearchDataTable.vue?vue&type=template&id=80ce532e"
import script from "./SearchDataTable.vue?vue&type=script&lang=js"
export * from "./SearchDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports